import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../../services/authService';
import { AuthContext } from '../../contexts/AuthContext';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPasswordValue] = useState('');
  const [message, setMessage] = useState({ type: '', text: '' });
  const [isLoading, setIsLoading] = useState(false);
  const { setAuthTokens } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    setIsLoading(true);
    login(email, password)
      .then((response) => {
        setMessage({ type: 'success', text: 'Login successful.' });
        setAuthTokens(response.data);
        navigate('/dashboard');
      })
      .catch((error) => {
        setMessage({
          type: 'error',
          text: error.response?.data?.error || 'Invalid credentials.',
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-900">
      <div className="p-8 bg-white rounded shadow-lg w-96">
        <h2 className="mb-6 text-2xl font-bold text-center text-gray-700">Login</h2>
        {message.text && (
          <div
            className={`mb-4 px-4 py-2 text-white rounded ${
              message.type === 'success' ? 'bg-green-500' : 'bg-red-500'
            }`}
          >
            {message.text}
          </div>
        )}
        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPasswordValue(e.target.value)}
            required
            className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
          <button
            type="submit"
            className="w-full px-4 py-2 font-bold text-white bg-purple-600 rounded hover:bg-purple-700"
            disabled={isLoading}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        <div className="mt-4 text-center">
          Don't have an account?{' '}
          <a href="/register" className="text-purple-600 hover:underline">
            Register
          </a>
        </div>
        <div className="mt-2 text-center">
          Or{' '}
          <a href="/otp-login" className="text-purple-600 hover:underline">
            Login with OTP
          </a>
        </div>
      </div>
    </div>
  );
}

export default Login;